import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const BottomNav = ({ currentView, onNavigate, onNewPlan, isCreatingPlan, onSignOut, onShowPrivacy, onShowTerms }) => {
  const { user } = useAuth();
  const [showMoreMenu, setShowMoreMenu] = useState(false);

  if (isCreatingPlan) {
    return null;
  }

  const signedInNavItems = [
    { id: 'dashboard', label: 'Dashboard', icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    )},
    { id: 'shared', label: 'Shared', icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    )},
    { id: 'new-plan', label: 'New', isAction: true },
    { id: 'billing', label: 'Billing', icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    )},
    { id: 'more', label: 'More', icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
      </svg>
    )}
  ];
  const signedOutNavItems = [
    { id: 'dashboard', label: 'Demo', icon: signedInNavItems[0].icon },
    { id: 'new-plan', label: 'New', isAction: true },
    { id: 'signin', label: 'Sign in', icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3" />
      </svg>
    )},
    { id: 'signup', label: 'Sign up', icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3M12 15a4 4 0 10-8 0v1h8v-1zm-4-4a3 3 0 100-6 3 3 0 000 6z" />
      </svg>
    )},
    { id: 'more', label: 'More', icon: signedInNavItems[4].icon }
  ];
  const navItems = (user ? signedInNavItems : signedOutNavItems).filter(item => {
    if (isCreatingPlan && item.id === 'new-plan') return false;
    return true;
  });

  const handleMoreClick = (action) => {
    setShowMoreMenu(false);
    if (action === 'home') onNavigate('home');
    else if (action === 'settings') onNavigate('settings');
    else if (action === 'help') onNavigate('help');
    else if (action === 'signin') onNavigate('signin');
    else if (action === 'signup') onNavigate('signup');
    else if (action === 'signout') onSignOut();
    else if (action === 'privacy') onShowPrivacy();
    else if (action === 'terms') onShowTerms();
  };

  return (
    <>
      {/* More Menu Overlay */}
      {showMoreMenu && (
        <div className="fixed inset-0 flex items-end justify-center bg-black/40 backdrop-blur-sm" style={{ zIndex: 9999 }} onClick={() => setShowMoreMenu(false)}>
          <div className="w-full max-w-lg bg-white rounded-t-3xl p-6 shadow-2xl animate-slide-up" onClick={e => e.stopPropagation()}>
            <div className="w-12 h-1.5 bg-gray-200 rounded-full mx-auto mb-6" />
            <h3 className="text-xl font-extrabold text-gray-900 mb-6 px-2">Menu</h3>
            
            <div className="grid grid-cols-1 gap-2">
              <button onClick={() => handleMoreClick('home')} className="flex items-center gap-4 p-4 rounded-2xl hover:bg-stone-50 transition-colors">
                <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9-9c1.657 0 3 4.03 3 9s-1.343 9-3 9m0-18c-1.657 0-3 4.03-3 9s1.343 9 3 9m-9-9h18" />
                  </svg>
                </div>
                <span className="font-bold text-gray-700">Explore Homepage</span>
              </button>
              
              <button onClick={() => handleMoreClick('settings')} className="flex items-center gap-4 p-4 rounded-2xl hover:bg-stone-50 transition-colors">
                <div className="w-10 h-10 rounded-xl bg-stone-100 flex items-center justify-center text-zinc-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><circle cx="12" cy="12" r="3" strokeWidth={2}/></svg>
                </div>
                <span className="font-bold text-gray-700">Settings</span>
              </button>

              <button onClick={() => handleMoreClick('help')} className="flex items-center gap-4 p-4 rounded-2xl hover:bg-stone-50 transition-colors">
                <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center text-amber-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.25 9.75a3.75 3.75 0 117.18 1.52c-.47.88-1.32 1.28-2.1 1.72-.74.42-1.33.84-1.33 1.76M12 18h.01M12 22a10 10 0 110-20 10 10 0 010 20z" />
                  </svg>
                </div>
                <span className="font-bold text-gray-700">Help Center</span>
              </button>

              {user ? (
              <button onClick={() => handleMoreClick('signout')} className="flex items-center gap-4 p-4 rounded-2xl hover:bg-red-50 transition-colors group">
                <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-400 group-hover:bg-red-100 group-hover:text-red-600 transition-colors">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                </div>
                <span className="font-bold text-gray-600 group-hover:text-red-600 transition-colors">Sign Out</span>
              </button>
              ) : (
              <button onClick={() => handleMoreClick('signin')} className="flex items-center gap-4 p-4 rounded-2xl hover:bg-stone-50 transition-colors">
                <div className="w-10 h-10 rounded-xl bg-stone-100 flex items-center justify-center text-zinc-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3" />
                  </svg>
                </div>
                <span className="font-bold text-gray-700">Sign in</span>
              </button>
              )}

              <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-center gap-6 px-2 pb-2">
                <button onClick={() => handleMoreClick('privacy')} className="text-[11px] font-bold text-gray-400 hover:text-zinc-900 uppercase tracking-wider">Privacy Policy</button>
                <div className="w-1 h-1 rounded-full bg-gray-200" />
                <button onClick={() => handleMoreClick('terms')} className="text-[11px] font-bold text-gray-400 hover:text-zinc-900 uppercase tracking-wider">Terms of Service</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <nav className="bottom-nav fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-lg border-t border-stone-200 safe-area-bottom md:hidden" style={{ zIndex: 60 }}>
        <div className="flex items-center justify-around h-16 px-2">
          {navItems.map((item) => {
            if (item.isAction) {
              return (
                <button
                  key={item.id}
                  onClick={onNewPlan}
                  disabled={isCreatingPlan}
                  className={`flex flex-col items-center justify-center -mt-8 transition-transform active:scale-95 z-50 relative ${isCreatingPlan ? 'opacity-50 grayscale cursor-not-allowed' : ''}`}
                >
                  <div className={`w-14 h-14 bg-zinc-900 rounded-full flex items-center justify-center text-white ring-4 ring-white relative ${isCreatingPlan ? 'shadow-none' : 'shadow-[0_4px_16px_rgba(24,24,27,0.25)]'}`}>
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  <span className="text-[10px] font-bold text-zinc-900 mt-1">{item.label}</span>
                </button>
              );
            }

            const isActive = currentView === item.id;

            return (
              <button
                key={item.id}
                onClick={() => {
                  if (item.id === 'more') setShowMoreMenu(true);
                  else onNavigate(item.id);
                }}
                className={`flex flex-col items-center justify-center w-16 h-full transition-colors ${isActive ? 'text-zinc-900' : 'text-gray-400'}`}
              >
                <div className={`p-1 rounded-lg transition-colors ${isActive ? 'bg-stone-100' : ''}`}>
                  {item.icon}
                </div>
                <span className={`text-[10px] font-medium mt-0.5 ${isActive ? 'font-bold' : ''}`}>{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
